<script>
  import { getContext } from 'svelte';
  export let message;
	export let onCancel = () => {};
	export let onOkay = () => {};

  const { close } = getContext('simple-modal');
	
	export let value;
	let onChange = () => {};
	
	function _onCancel() {
		onCancel();
		close();
	}
	
	function _onOkay() {
		onOkay(value);
		close();
	}
	
	$: onChange(value)
</script>

<style>
  h2 {
		font-size: 2rem;
		text-align: center;
	}
	
	input {
		width: 100%;
	}
	
	.buttons {
		display: flex;
		justify-content: space-between;
	}
	
	.close {
		position: absolute;
		top: -2rem;
		right: 0;
		background: black;
	}
</style>

<button class="close" on:click={_onCancel}>
	Close
</button>

<h2>{message}</h2>

<div class="buttons">
	<button on:click={_onCancel}>
		Abbrechen
	</button>
	<button on:click={_onOkay}>
		Speichern
	</button>
</div>